<mat-toolbar color="accent">
  <h1><a routerLink="">SolidCryptPad</a></h1>
  <ul>
    <li routerLinkActive="active" *appLoggedIn>
      <a routerLink="home">Home</a>
    </li>

    <li routerLinkActive="active" *appLoggedIn>
      <a routerLink="files">Files</a>
    </li>
    <li routerLinkActive="active"><a routerLink="faq">FAQ</a></li>
  </ul>

  <span class="spacer"></span>

  <div *appLoggedIn style="margin-right: 1em">
    <button mat-stroked-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon data-cy="nav-account-icon">account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="changeMasterPassword()">
        Change Password
      </button>
      <button mat-menu-item [routerLink]="['/links']">Created Links</button>
      <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
  </div>

  <mat-icon style="margin-right: 0.5em">brightness_5</mat-icon>
  <mat-slide-toggle
    style="margin-right: 0.5em"
    [formControl]="toggleControl"
    (change)="toggleDarkMode($event)"
    ngDefaultControl
  >
  </mat-slide-toggle>
  <mat-icon>bedtime</mat-icon>
</mat-toolbar>
